import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-global--websocket" id="module-global--websocket"></a>
    <h1 {...{
      "id": "windowwebsocket"
    }}>{`window.WebSocket`}</h1>
    <a name="new-module-global--websocket-new" id="new-module-global--websocket-new"></a>
    <h2 {...{
      "id": "websocketurl-protocols"
    }}>{`WebSocket(url, protocols)`}</h2>
    <p>{`WebSocket provides the API for creating and managing a WebSocket connection to a server,
as well as for sending and receiving data on the connection.
In order to leverage `}<inlineCode parentName="p">{`WebSocket`}</inlineCode>{`, update the `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` with the `}<inlineCode parentName="p">{`network.domains`}</inlineCode>{` permission shown in the example section`}</p>
    <b>Example:</b>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "permissions": {
      "network": {
          "domains": [
              "https://www.adobe.com",
              "https://*.adobeprerelease.com",
              "wss://*.myplugin.com"
          ]
      }
  }
}
`}</code></pre>
    <b>Limitation:</b>
From UXP v7.4.0 onwards `permissions.network.domains` does not support WildCards in top-level domains.
Example:
```json
"domains": [ "https://www.adobe.*", "https://www.*" ]
```
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` If invalid url or protocols is passed`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`URL to which to connect; this should be the URL to which the WebSocket server will respond.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`protocols`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Array<string>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Either a single protocol string or an array of protocol strings.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`var ws = new WebSocket("wss://demos.kaazing.com/echo","wss");
`}</code></pre>
    <a name="module-global--websocket-readystate" id="module-global--websocket-readystate"></a>
    <h2 {...{
      "id": "readystate--number"
    }}>{`readyState : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Current state of the WebSocket connection.
One of the following values:`}</p>
    <table>
  <tr>
    <th>Number</th>
    <th>Status</th>
    <th>Description</th>
  </tr>
  <tr>
    <td>0</td>
    <td>CONNECTING</td>
    <td>Socket has been created. The connection is not yet opened.</td>
  </tr>
  <tr>
    <td>1</td>
    <td>OPEN</td>
    <td>Connection is open and ready to communicate.</td>
  </tr>
  <tr>
    <td>2</td>
    <td>CLOSING</td>
    <td>Connection is in the process of closing.</td>
  </tr>
  <tr>
    <td>3</td>
    <td>CLOSED</td>
    <td>Connection is closed or couldn't be opened.</td>
  </tr>
    </table>
    <a name="module-global--websocket-url" id="module-global--websocket-url"></a>
    <h2 {...{
      "id": "url--string"
    }}>{`url : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
URL of the WebSocket as resolved by the constructor.`}</p>
    <a name="module-global--websocket-protocol" id="module-global--websocket-protocol"></a>
    <h2 {...{
      "id": "protocol--string"
    }}>{`protocol : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Name of the sub-protocol the server selected.
This will be one of the strings specified in the protocols parameter when creating the WebSocket object.
It returns an empty string if no connection is established.`}</p>
    <a name="module-global--websocket-bufferedamount" id="module-global--websocket-bufferedamount"></a>
    <h2 {...{
      "id": "bufferedamount--number"
    }}>{`bufferedAmount : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Number of bytes of data that have been queued using calls to send() but not yet transmitted to the network.
This value resets to zero once all queued data has been sent.
This value does not reset to zero when the connection is closed;
If you keep calling send(), this will continue to climb.`}</p>
    <a name="module-global--websocket-binarytype" id="module-global--websocket-binarytype"></a>
    <h2 {...{
      "id": "binarytype--string"
    }}>{`binaryType : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Type of the binary data being received over WebSocket connection.
Available binary types: "blob", "arraybuffer".`}</p>
    <a name="module-global--websocket-send" id="module-global--websocket-send"></a>
    <h2 {...{
      "id": "senddata"
    }}>{`send(data)`}</h2>
    <p>{`Enqueues the specified data to be transmitted to the other end over the WebSocket connection,
increasing the value of bufferedAmount by the number of bytes needed to contain the data.
If the data can't be sent (for example, because it needs to be buffered but the buffer is full), the socket is closed automatically.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBufferView`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data to send to the server.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`ws.send(new Float32Array([ 5, 2, 1, 3, 6, -1 ]))
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`ws.send(new Int32Array([5,-1]).buffer)
`}</code></pre>
    <a name="module-global--websocket-close" id="module-global--websocket-close"></a>
    <h2 {...{
      "id": "closecode-reason"
    }}>{`close(`}{`[code]`}{`, `}{`[reason]`}{`)`}</h2>
    <p>{`Closes the websocket connection.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` If invalid code or reason is passed`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[code]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer value as per `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/API/WebSocket#close()"
            }}>{`https://developer.mozilla.org/en-US/docs/Web/API/WebSocket#close()`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[reason]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Human-readable string explaining why the connection is closing. The default value is "".`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      